import React, { Component } from "react";
import ContentBody from "../components/ContentBody";
import ArticleList from "../components/ArticleList";
import PageHeader from "../components/PageHeader";
import Language from "../utils/Language";

class PageForDevs extends Component {
  render() {
    return (
      <ContentBody>
        <PageHeader
          eyebrow={Language.GetString("dev_page_eyebrow")}
          title={Language.GetString("dev_page_title")}
          subtitle={Language.GetString("dev_page_subtitle")}
        />
        <ArticleList articles={require("../products/dev_tools.json")} />
      </ContentBody>
    );
  }
}

export default PageForDevs;
